import { ReactComponent as ArrowDown_Comparison } from "assets/ArrowDown_Comparison.svg";
import { ReactComponent as ArrowRight } from "assets/ArrowRight.svg";
import { ReactComponent as UserCircleSmall } from "assets/UserCircleSmall.svg";
import { getUserAccessPermissions } from "components/app/App.slice";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import RadioButton from "components/common/RadioButton";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { convertYNToStatus, getLoggedInUserHltId } from "utils/CommonFunctions";
import { responseTypes } from "utils/Types";
import { routes } from "utils/routes";
import { getFormatedData, getInitialState, labelFromKey } from "./AdminConsole";
import { updateEditPermissions } from "./AdminConsole.slice";

const EditPermission = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const translate = useTranslate();

  const data = location?.state?.userPermissionDetail;
  const formattedData = getFormatedData(data);
  const initialState: { [key: string]: string } = getInitialState(data);
  const convertableKeys = ["adminConsoleAccess"];

  const [payload, setPayload] = useState(initialState);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const userName = data?.displayName || data?.firstName + data?.lastName || "";

  const getMemberInfo = (el: any = data) => {
    return (
      <div>
        <Typography
          variant={"h4"}
          showBold
          color={tokens.Text.General.PrimaryHeadline}
          component={"div"}
          sx={{ marginBottom: "8px" }}
        >
          {userName}
        </Typography>
        <Typography variant="body2" color={tokens.Text.General.PrimaryBody} component={"div"}>
          {el?.email}
        </Typography>
        <Typography variant={"label"} color={tokens.Text.General.Tertiary} component={"div"}>
          {el?.hltId}
        </Typography>
      </div>
    );
  };

  const getConfirmationData = (dataList: any, isBoldCheck: boolean = false) => {
    return Object.entries(dataList)?.map((el: any) => {
      const showBoldVal = isBoldCheck && el[1] !== initialState[el[0]];
      let val = convertableKeys.includes(el[0]) ? convertYNToStatus(el[1]) : el[1];

      return (
        <div key={el[0]}>
          <Typography variant={"body2"} color={tokens.Text.General.Secondary} component={"span"}>
            {labelFromKey[el[0]]}
          </Typography>
          {` - `}
          <Typography variant={"body2"} color={tokens.Text.General.Secondary} component={"span"} showBold={showBoldVal}>
            {val}
          </Typography>
        </div>
      );
    });
  };

  const handleChange = (key: string, value: string) => {
    const payloadData = { ...payload, [key]: value };
    setPayload(payloadData);
  };
  const handleClose = () => {
    setOpenConfirmDialog(false);
  };

  const handleSubmit = async () => {
    const payloadData = { ...payload, hltId: data?.hltId };
    const resp = await dispatch(updateEditPermissions(payloadData));
    if (resp.payload.status === responseTypes.success) {
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          variant: "success",
          setState: setFeedbackDetails({ shouldShow: false }),
          message: translate("adminConsole.editPermission.successMessage")
        })
      );
      if (data?.hltId === getLoggedInUserHltId()) {
        dispatch(
          getUserAccessPermissions({
            hltId: [getLoggedInUserHltId()]
          })
        );
      }
      setOpenConfirmDialog(false);
      navigate(routes.AdminConsole);
    }
  };
  const countDifferences = () => {
    return Object.keys(initialState).reduce((count, key) => {
      return initialState[key] !== payload[key] ? count + 1 : count;
    }, 0);
  };

  return (
    <>
      <div className="edit-permission-component">
        <div className="edit-permission-left-container">{getMemberInfo()}</div>
        <div className="edit-permission-right-container">
          <div className="right-container-radio-button-wrapper">
            {" "}
            {formattedData?.map((item: any) => {
              return (
                <RadioButton
                  key={item.label}
                  label={item.label}
                  selectedOption={item.selected}
                  options={item.options}
                  handleChange={(e: any) => handleChange(item.key, e.target.value)}
                  labelHelperText={item?.labelHelperText}
                  optionHelperText={item?.optionHelperText}
                />
              );
            })}
          </div>

          <div className="right-container-action-buttons">
            <Button label={"Cancel Changes"} variant="outlined" onClick={() => navigate("/adminconsole")} />
            <Button
              disabled={!countDifferences()}
              label={countDifferences() ? `Apply Changes (${countDifferences()})` : "Apply Changes"}
              onClick={() => setOpenConfirmDialog(true)}
            />
          </div>
        </div>
      </div>
      {openConfirmDialog && (
        <DialogFormation
          title={"Edit Permissions confirmation"}
          openDialog={openConfirmDialog}
          handleClose={handleClose}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" onClick={handleClose} label="Cancel" />
              <Button variant="primary" label="Save" onClick={handleSubmit} />
            </div>
          }
        >
          <div className="confirmation-dialog-component">
            <div className="confirmation-dialog-container-top">
              <div className="confirmation-dialog-subheading">
                {" "}
                <UserCircleSmall />
                <Typography
                  variant={"body2"}
                  color={tokens.Text.General.PrimaryBody}
                  showBold
                  sx={{ marginLeft: "8px" }}
                >
                  {userName}
                </Typography>
                <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody} sx={{ marginLeft: "4px" }}>
                  {data?.hltId}
                </Typography>
              </div>
              <div className="confirmation-dialog-wrapper">
                {" "}
                <div className="confirmation-dialog-left-wrapper">
                  <div>{getConfirmationData(initialState)}</div>
                </div>
                <div className="arrow-right">
                  <ArrowRight />
                </div>
                <div className="arrow-down">
                  <ArrowDown_Comparison />
                </div>
                <div className="confirmation-dialog-right-wrapper">{getConfirmationData(payload, true)}</div>
              </div>
            </div>
            <div className="confirmation-dialog-container-bottom">
              <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody} className="wh">
                {translate("adminConsole.confirmation")}
              </Typography>
            </div>
          </div>
        </DialogFormation>
      )}
    </>
  );
};
export default EditPermission;
